import React from 'react'
import { Routes, Route, Link } from "react-router-dom";
import About from '../About';
import Details from '../Details';
import Home from '../Home';


function Top() {
  return (
    <>
<section className='top1'>
   <nav className="navbar navbar-expand-sm sticky-top navbar-light bg-light">
    <div className="container-fluid ">
      <Link className="navbar-brand" to="/"><img width={100} src="https://www.smilefoundationindia.org/wp-content/uploads/2022/09/SMILE-FOUNDATION-LOGO-e1662456150120-1.png" alt /></Link>
      <button className="navbar-toggler navbar-toggler-right" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon" />
      </button>
      <div className="collapse navbar-collapse align-self-end " id="navbarSupportedContent">
        <ul className="navbar-nav mx-auto mb-2 mb-lg-0 ">
          <li className="nav-item dropdown ">
            <a className="nav-link dropdown-toggle" href='#' role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <strong>ABOUT US</strong> 
            </a>
            <ul className="dropdown-menu">
              <li><a className="dropdown-item" href={`/about`}>About Us</a></li>
              <li><a className="dropdown-item py-1" href={`/details`}>People Behind Smile <i class="bi bi-caret-right-fill "></i></a>
                  <ul className='dropdown-menu dropdown-submenu text-center'>
                      <a href={`/details`}><li className='py-1'>Leadership</li></a>
                      <a href={`/details`}><li className='py-1'>Mentors</li></a>
                      <a href={`/details`}><li className='py-1'>Our People</li></a>
                  </ul>              
              </li>
              <li><a className="dropdown-item py-1" href={`/details`}>Impact</a></li>
              <li><a className="dropdown-item py-1" href={`/details`}>Reach &amp; Presence</a></li>
              <li><a className="dropdown-item py-1" href={`/details`}>Civic Driven Change</a></li>
              <li><a className="dropdown-item py-1" href={`/details`}>Smilestones</a></li>
              <li><a className="dropdown-item" href={`/details`}>Good Governance</a></li>
            </ul>
          </li>
          <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href={`/details`} role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <strong> OUR WORK</strong>
            </a>
            <ul className="dropdown-menu">
              <li><a className="dropdown-item" href={`/details`}>Education</a></li>
              <li><a className="dropdown-item py-1" href={`/details`}>Health</a></li>
              <li><a className="dropdown-item py-1" href={`/details`}>Livelihood</a></li>
              <li><a className="dropdown-item py-1" href={`/details`}>Women Empowerment</a></li>
              <li><a className="dropdown-item py-1" href={`/details`}>Disaster Response</a></li>
              <li><a className="dropdown-item" href="#">Empowering Grassroots <i class="bi bi-caret-right-fill "></i></a>
                  <ul className='dropdown-menu dropdown-submenu text-center'>
                      <a href={`/details`}><li className='py-1'>What We Do</li></a>
                      <a href={`/details`}><li className='py-1'>CTGI</li></a>
                  </ul>
              </li>
              <li><a className="dropdown-item" href={`/details`}>Privileged Children <i class="bi bi-caret-right-fill "></i></a>
                  <ul className='dropdown-menu dropdown-submenu text-center'>
                      <a href={`/details`}><li className='py-1'>Child For Child</li></a>
                      <a href={`/details`}><li className='py-1'>Siffcy</li></a>
                  </ul>
              </li>
            </ul>
          </li>
          <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href={`/details`} role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <strong>CAMPAIGNS</strong> 
            </a>
            <ul className="dropdown-menu">
              <li><a className="dropdown-item" href={`/details`}>Tayyari Kal Ki</a></li>
              <li><a className="dropdown-item" href={`/details`}> Shiksha Na Ruke</a></li>
              <li><a className="dropdown-item" href={`/details`}> Health Cannot Wait</a></li>
              <li><a className="dropdown-item" href={`/details`}> She Can Fly</a></li>
            </ul>
          </li>
          <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href={`/details`} role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <strong>GET INVOLVED</strong> 
            </a>
            <ul className="dropdown-menu">
              <li><a className="dropdown-item" href={`/details`}>Individual Support</a></li>
              <li><a className="dropdown-item py-1" href={`/details`}> Corporate Partnerships</a></li>
              <li><a className="dropdown-item py-1" href={`/details`}> School Partnerships</a></li>
              <li><a className="dropdown-item py-1" href={`/details`}> Volunteers & Internships</a></li>
              <li><a className="dropdown-item" href={`/details`}> Work With Us</a></li>
            </ul>
          </li>
          <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href={`/details`} role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <strong>MEDIA CENTER</strong> 
            </a>
            <ul className="dropdown-menu"> 
              <li><a className="dropdown-item" href="#">Press Releases</a></li>
              <li><a className="dropdown-item py-1" href={`/details`}>Print/ Online Media </a></li>
              <li><a className="dropdown-item py-1" href={`/details`}>Electronic Media </a></li>
              <li><a className="dropdown-item py-1" href={`/details`}>Workshop & Events </a></li>
              <li><a className="dropdown-item" href={`/details`}>Eminent Personalities </a></li>
            </ul>
          </li>
          <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href={`/details`} role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <strong>RESOURSE CENTER</strong> 
            </a>
            <ul className="dropdown-menu">
              <li><a className="dropdown-item" href={`/details`}>The Smile Blog</a></li>
              <li><a className="dropdown-item py-1" href={`/details`}>Newsletter</a></li>
              <li><a className="dropdown-item py-1" href={`/details`}> Annual Report</a></li>
              <li><a className="dropdown-item py-1" href={`/details`}> Films</a></li>
              <li><a className="dropdown-item py-1" href={`/details`}> Stories of Change</a></li>
              <li><a className="dropdown-item" href={`/details`}> Perspective <i class="bi bi-caret-right-fill "></i></a>
                  <ul className='dropdown-menu dropdown-submenu text-center'>
                      <a href={`/details`}><li className='py-1'>Child Rights</li></a>
                      <a href={`/details`}><li className='py-1'>Child Labour Policy</li></a>
                  </ul>
              </li>
            </ul>
          </li>
          <li className="nav-item dropdown">
            <a className="nav-link dropdown-toggle" href={`/details`} role="button" data-bs-toggle="dropdown" aria-expanded="false">
              <strong>CONTACT US</strong>  
            </a>
            <ul className="dropdown-menu">
              <li><a className="dropdown-item py-1 py-1" href={`/details`}>Get In Touch</a></li>
              <li><a className="dropdown-item" href={`/details`}>FAQs</a></li>
            </ul>
          </li>
        </ul>
        <a target="_blank" href='https://donate.smilefoundationindia.org/donate-for-education' ><div type="button" className="btn btn-1">SUPPORT A CAUSE</div></a>
      </div>
    </div></nav>
</section>
 





<Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About   />} />
        <Route path="/details" element={<Details  />} />
        
      </Routes>
    </>
  )
}

export default Top